"use client";

import type useLifestyleFilters from "../../hooks/useLifestyleFilters";
import { BUCKET_FILTERS, RANGE_FILTERS } from "../../lifestyle-constants";
import FacetList from "./FacetList";
import type { FilterScreenDefinition } from "./filterScreens";
import RangeSliderField from "./RangeSliderField";

interface FilterScreenProps {
  filter: FilterScreenDefinition;
  filters: ReturnType<typeof useLifestyleFilters>;
}

const LIST_CLASS = "flex flex-col flex-1 min-h-0 px-4 pt-3 pb-8 overflow-y-auto";

/** The third level of the drawer: one filter, filling the panel. */
export default function FilterScreen({ filter, filters }: FilterScreenProps) {
  if (filter.key === "makes" || filter.key === "styles") {
    const isMakes = filter.key === "makes";

    return (
      <div className={LIST_CLASS}>
        <FacetList
          legend={filter.label}
          facets={isMakes ? filters.makeFacets : filters.styleFacets}
          onToggle={isMakes ? filters.toggleMake : filters.toggleStyle}
        />
      </div>
    );
  }

  const bucket = BUCKET_FILTERS.find(entry => entry.key === filter.key);
  if (bucket) {
    return (
      <div className={LIST_CLASS}>
        <FacetList
          legend={bucket.label}
          facets={filters.bucketFacets[bucket.key]}
          onToggle={bucketId => filters.toggleBucket(bucket.key, bucketId)}
        />
      </div>
    );
  }

  const range = RANGE_FILTERS.find(entry => entry.key === filter.key);
  if (!range) return null;

  return (
    <div className="flex flex-col flex-1 min-h-0 px-4 pt-3 pb-8 overflow-y-auto">
      <RangeSliderField
        label={range.label}
        bounds={filters.bounds[range.key]}
        value={filters.filters.ranges[range.key]}
        format={range.format}
        onChange={value => filters.setRange(range.key, value)}
      />
    </div>
  );
}
